import { plugin, Mode, useLightContext } from 'light-component';
import { Struct } from 'shoteyes-types';
import { useTranslation } from '@common';
import { Thumbnail } from '../../component';
import { WidgetKind, WidgetType } from '../types';
import { TextAreaDesignMode } from './design';
import { TextAreaInputMode } from './input';
import { TextAreaViewMode } from './view';
import type { ReactElement } from 'react';
import type { TextAreaProps } from './types';

export function TextArea(props: TextAreaProps): ReactElement | null {
  const [t] = useTranslation();

  const { source } = useLightContext();
  // 是否是巡店模板
  const isShoteyesForm = source != null && (source as Struct.Form).type === Struct.FormType.CHECK;
  if (props.mode === Mode.THUMBNAIL) {
    return (<Thumbnail icon='TextAreaIcon' title={t('TextArea')}
      toolTipContent={isShoteyesForm ? t('较多字数文字记录，不影响报告分数') : t('较多字数文字记录')} />);
  }

  if (props.mode === Mode.DESIGN) {
    return (<TextAreaDesignMode {...props} initTitle={t('TextArea')} />);
  }

  if (props.mode === Mode.VIEW) {
    return (<TextAreaViewMode {...props} />);
  }

  if (props.mode === Mode.INPUT) {
    return (<TextAreaInputMode {...props} />);
  }

  return null;
}

TextArea.prototype.type = WidgetType.TEXTAREA;
plugin.register({ kind: WidgetKind.WIDGET, component: TextArea });
